import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";

const services = [
  {
    title: "Mantenimiento correctivo y preventivo",
    description:
     "Ofrecemos mantenimiento especializado de equipos informáticos y periféricos. Nuestros servicios incluyen diagnóstico, limpieza, reparación y optimización de hardware y software, asegurando la continuidad operativa y el rendimiento óptimo de los sistemas.",
    image: require("../../static/media/service/service2.webp"),
  },
  {
    title: "Venta de sistemas de video vigilancia",
    description:
      "Brindamos soluciones integrales en seguridad electrónica, incluyendo la instalación y configuración de sistemas de videovigilancia con cámaras IP, DVR y NVR. Nuestros sistemas permiten monitoreo remoto y grabación continua, garantizando control y protección 24/7.",
    image: require("../../static/media/service/service3.webp"),
  },
  {
    title: "Mantenimiento correctivo y preventivo",
    description:
      "Ofrecemos mantenimiento especializado de equipos informáticos y periféricos. Nuestros servicios incluyen diagnóstico, limpieza, reparación y optimización de hardware y software, asegurando la continuidad operativa y el rendimiento óptimo de los sistemas.",
    image: require("../../static/media/service/service4.webp"),
  },
];

const ServiceSoftware = () => (
  <Box
    sx={{
      background: "linear-gradient(135deg, #f6fbff, #ffffff)",
      py: { xs: 6, md: 10 },
      px: { xs: 2, md: 4 },
    }}
  >
    <Typography
      component="h3"
      sx={{
        fontWeight: "bold",
        textAlign: "center",
        mb: { xs: 4, md: 6 },
        fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
        color: "#e65100",
      }}
    >
      Servicios Especializados
    </Typography>

    <Grid container spacing={4} justifyContent="center">
      {services.map((item, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                maxWidth: { xs: 280, sm: 300, md: 340 },
                minHeight: { xs: "auto", sm: 300, md: 400 },
                mx: "auto",
                backgroundColor: "#ffffff",
                borderRadius: 3,
                overflow: "hidden",
                boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={item.title}
                sx={{
                  width: "100%",
                  height: { xs: 140, sm: 160, md: 180 },
                  objectFit: "cover",
                }}
              />
              <Box
                sx={{
                  p: { xs: 2, md: 3 },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <Typography
                  component="h4"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.95rem", sm: "1.15rem", md: "1.3rem" },
                    mb: 1.5,
                    color: "#ff6700",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#444",
                    fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                    lineHeight: 1.6,
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
          </motion.div>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default ServiceSoftware;
